import React from "react";
import PropTypes from "prop-types";
// ui
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Badge from "@mui/material/Badge";
// style
import { styled } from "@material-ui/styles";

const StyledListItem = styled(ListItem)(({ theme }) => ({
  "&.MuiListItem-root": {
    width: "100%",
    borderBottom: "1px #CECECE solid",
    "& .MuiListItemSecondaryAction-root": {
      right: "8px",
    },
  },
}));

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  "&.MuiListItemButton-root": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%", // 设置宽度为100%
    padding: "0px 4px 0px 0px ",
    overflow: "hidden",
  },
}));

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  "&.MuiListItemText-root": {
    fontSize: "14px",
    flex: "1", // 设置文本容器为自适应宽度
  },
}));

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  "&.MuiListItemIcon-root": {
    minWidth: "fit-content",
  },
}));

const StyledLBadge = styled(Badge)(({ theme }) => ({
  "&.MuiBadge-root": {
    maxWidth: "calc(100% - 42px)",
    "& .MuiBadge-badge": {
      top: "15px",
      right: "-20px",
    },
  },
}));

//
const ListItemImgArea = ({
  listIcon,
  textPrimary,
  textSecondary,
  listItemProps,
  listItemIconProps,
  listItemButtonProps,
  listItemTextProps,
  badgeListProps,
  sx,
}) => {
  const getSx = () => {
    if (sx) return sx;
    return {};
  };

  return (
    <StyledListItem disablePadding {...listItemProps} sx={getSx()}>
      {listIcon && (
        <StyledListItemIcon {...listItemIconProps}>
          {listIcon}
        </StyledListItemIcon>
      )}
      <StyledListItemButton {...listItemButtonProps}>
        <StyledLBadge {...badgeListProps}>
          <StyledListItemText
            disableTypography
            primary={textPrimary}
            secondary={textSecondary}
            {...listItemTextProps}
          />
        </StyledLBadge>
      </StyledListItemButton>
    </StyledListItem>
  );
};

ListItemImgArea.propTypes = {
  listIcon: PropTypes.node,
  textPrimary: PropTypes.node,
  textSecondary: PropTypes.node,
  listItemProps: PropTypes.objectOf(PropTypes.any),
  listItemIconProps: PropTypes.objectOf(PropTypes.any),
  listItemButtonProps: PropTypes.objectOf(PropTypes.any),
  listItemTextProps: PropTypes.objectOf(PropTypes.any),
  badgeListProps: PropTypes.objectOf(PropTypes.any),
  sx: PropTypes.objectOf(PropTypes.any),
};

ListItemImgArea.defaultProps = {
  listIcon: null,
  textPrimary: "",
  textSecondary: "",
  listItemProps: {},
  listItemIconProps: {},
  listItemButtonProps: {},
  listItemTextProps: {},
  badgeListProps: {},
  sx: {},
};

export default ListItemImgArea;
